module.exports = __webpack_public_path__ + "img/teacher_image.69f9caac.png";